import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var DURATIONS = {
  SLOW: "slow",
  NORMAL: "normal",
  FAST: "fast"
};

var transition = function transition(properties, duration, timingFunction) {
  return function (_ref) {
    var _tokens;

    var theme = _ref.theme;
    var tokens = (_tokens = {}, _defineProperty(_tokens, DURATIONS.SLOW, theme.orbit.durationSlow), _defineProperty(_tokens, DURATIONS.NORMAL, theme.orbit.durationNormal), _defineProperty(_tokens, DURATIONS.FAST, theme.orbit.durationFast), _tokens);
    return "\n    ".concat(properties.map(function (property) {
      return "".concat(property, " ").concat(tokens[duration], " ").concat(timingFunction);
    }).join(","), ";\n  ");
  };
};

export default transition;